import {BelegAktualisierungenDTO} from '../../openapi/fakturierung-openapi';


/**
 * Aktualisierbare Datenbereiche je Beleg, geladen ueber den separaten
 * aktualisierungen-Endpoint.
 */
export interface BelegAktualisierungenState {
  byBelegId: Record<string, BelegAktualisierungenDTO>;
}


export const initialBelegAktualisierungenState: BelegAktualisierungenState = {
  byBelegId: {},
};
